import * as Html from "../../util/Html.ts";
import * as Redim from "../../lib/redim/imageRedim.ts";
import * as Medias from "../../server/Medias.ts";
import Icons from "../../svg/Icons.ts";
import { acceptFiles } from "../../lib/FileUtils.ts";

export {initDom}
Html.registerWidget('widget/form/input-image',{initDom})

function initDom(node: HTMLElement){
  const inputFile = node.querySelector('input') as HTMLInputElement;
  const imgTag = node.querySelector('img') as HTMLImageElement;
  const icon = node.querySelector('icon') as HTMLElement;
  const rect = node.getBoundingClientRect();
  const isSmall = rect.width < 80;
  const nocontroll = node.getAttribute("data-ui") === "nocontroll";

  if(!inputFile) return;

  node.classList.add("input-image");

  if(!inputFile.disabled && !nocontroll){
    const commonStyle = isSmall ? "padding:2px;width:16px;height:16px;line-height:16px;top:-6px;right:-6px" : "zoom:85%;";
    node.insertAdjacentHTML('beforeend', '<ib class="picture-delete" style="'+commonStyle+'">'+Icons.ic_close+'</ib>');
    node.insertAdjacentHTML('beforeend', '<ib class="picture-reset"  style="'+commonStyle+'">'+Icons.ic_repeat+'</ib>');
  }

  const deleteTag = node.querySelector('.picture-delete') as HTMLElement;
  const resetTag = node.querySelector('.picture-reset') as HTMLElement;
  const originalValue = node.getAttribute("data-value") || inputFile.getAttribute("data-value");
  const deletedValue = node.getAttribute("data-default");
  let value = originalValue;


  function setPreview(thumb: string | null){
    value = thumb;
    if(isSmall && icon){
      icon.style.display = thumb === null ? '' : 'none';
    }
    if(nocontroll){
      const inputControll = node.querySelector('.input-controll') as HTMLElement;
      if(inputControll) {
        inputControll.style.visibility = value ? "hidden" : "visible";
      }
    }
    if(imgTag){
      if(value || deletedValue){
        imgTag.src = value || deletedValue;
        imgTag.style.visibility = "visible";
      }else{
        imgTag.style.visibility = "hidden";
      }
    }else{
      if(value || deletedValue){
        node.style.backgroundPosition = "50%";
        node.style.backgroundSize = "cover";
        node.style.backgroundImage = `url('${value || deletedValue}')`;
      }else{
        node.style.backgroundImage = 'unset';
      }
    }

    if(deleteTag) deleteTag.style.display = value !== null ? '' : 'none';
    if(resetTag) resetTag.style.display = value === null && !!originalValue ? '' : 'none';
    //IMPORTANT it is read by SRV to dectect that $empty should be sent
    (inputFile as any).empty = value === null;
  }
  setPreview(value || null);

  if(deleteTag) {
    deleteTag.addEventListener("click", function(e){
      e.stopPropagation();
      e.preventDefault();
      inputFile.value = '';
      inputFile.dispatchEvent(new Event('change'));
    });
  }

  if(resetTag) {
    resetTag.addEventListener("click", function(e){
      e.stopPropagation();
      e.preventDefault();
      setPreview(originalValue);
    });
  }

  inputFile.addEventListener('change', async function(this: HTMLInputElement){
    if(!await Medias.checkQuota()) return;
    if(!this.files || !this.files[0]){
      setPreview(null);
      return;
    }
    if(!acceptFiles(this, this.files)){
      Html.trigger(null,'takepremium')
      setPreview(null);
      inputFile.value = '';
      return;
    }
    const rect = node.getBoundingClientRect();
    const thumb = await Redim.thumbnail(this.files[0], {width:rect.width, height:rect.height})
    setPreview(thumb)
  });
}


